var chunkMapping = {
	"165": [
		70165
	]
};
var idToExternalAndNameMapping = {
	"70165": [
		"default",
		"./AprendizajeForm",
		43428
	]
};
var idToRemoteMap = {
	"70165": [
		{
			"externalType": "script",
			"name": "mfAprendizaje",
			"externalModuleId": 43428
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}